import { IQuoteTemplateState } from '@/store/quotetemplate';
import { IQuoteTemplateGetters } from './getters.types';
import {
  IQuoteFreightTemplate,
  IQuotePaymentTermCode,
  IQuotePaymentTermTemplate,
  IQuoteServiceTemplate,
  IQuoteTermTemplate,
  QuoteFreightTemplate,
  QuotePaymentTermTemplate,
  QuoteServiceTemplate,
  QuoteTermTemplate
} from '@/models';

export const getters: IQuoteTemplateGetters = {
  getQuoteServiceTemplates(
    state: IQuoteTemplateState
  ): IQuoteServiceTemplate[] {
    return state.serviceTemplates.map(
      template => new QuoteServiceTemplate(template)
    );
  },
  getQuoteServiceTemplateById: (state: IQuoteTemplateState) => (
    id: number
  ): IQuoteServiceTemplate | undefined => {
    const data = state.serviceTemplates.find(template => template.id === id);
    if (!data) {
      return undefined;
    }
    return new QuoteServiceTemplate(data);
  },

  // FREIGHTS
  getQuoteFreightTemplates(
    state: IQuoteTemplateState
  ): IQuoteFreightTemplate[] {
    return state.freightTemplates.map(
      template => new QuoteFreightTemplate(template)
    );
  },

  getQuoteFreightTemplateById: (state: IQuoteTemplateState) => (
    id: number
  ): IQuoteFreightTemplate | undefined => {
    const data = state.freightTemplates.find(template => template.id === id);
    if (!data) {
      return undefined;
    }

    return new QuoteFreightTemplate(data);
  },

  // PAYMENT TERM
  getActiveQuotePaymentTermTemplates(
    state: IQuoteTemplateState
  ): IQuotePaymentTermTemplate[] {
    return state.paymentTermTemplates
      .filter(template => !template.is_archived)
      .map(template => new QuotePaymentTermTemplate(template));
  },

  getArchivedQuotePaymentTermTemplates(
    state: IQuoteTemplateState
  ): IQuotePaymentTermTemplate[] {
    return state.paymentTermTemplates
      .filter(template => template.is_archived)
      .map(template => new QuotePaymentTermTemplate(template));
  },

  getQuotePaymentTermTemplateById: (state: IQuoteTemplateState) => (
    id: number
  ): IQuotePaymentTermTemplate | undefined => {
    const data = state.paymentTermTemplates.find(
      template => template.id === id
    );
    if (!data) {
      return undefined;
    }

    return new QuotePaymentTermTemplate(data);
  },

  getQuotePaymentTermTemplateByCode: (state: IQuoteTemplateState) => (
    code: string
  ): IQuotePaymentTermTemplate | undefined => {
    const data = state.paymentTermTemplates.find(
      template =>
        template.code && (template.code as IQuotePaymentTermCode).code === code
    );
    if (!data) {
      return undefined;
    }

    return new QuotePaymentTermTemplate(data);
  },

  // TERM
  getQuoteTermTemplates(state: IQuoteTemplateState): IQuoteTermTemplate[] {
    return state.termTemplates.map(template => new QuoteTermTemplate(template));
  },

  getQuoteTermTemplatesByOrganization: (state: IQuoteTemplateState) => (
    organization: number
  ): IQuoteTermTemplate[] => {
    const filteredTemplates = state.termTemplates.filter(
      template => template.organization === organization
    );

    return filteredTemplates.map(template => new QuoteTermTemplate(template));
  },

  getQuoteTermTemplateById: (state: IQuoteTemplateState) => (
    id: number
  ): IQuoteTermTemplate | undefined => {
    const data = state.termTemplates.find(template => template.id === id);
    if (!data) {
      return undefined;
    }

    return new QuoteTermTemplate(data);
  }
};
